import { render } from "./ResignationView.vue?vue&type=template&id=6e115ca0&scoped=true"
import script from "./ResignationView.vue?vue&type=script&lang=js"
export * from "./ResignationView.vue?vue&type=script&lang=js"

import "./ResignationView.vue?vue&type=style&index=0&id=6e115ca0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e115ca0"]])

export default __exports__